import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconCrossSmall = function IconCrossSmall(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-cross-small"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 9.62132L11.4394 13.0607C11.6347 13.2559 11.9513 13.2559 12.1465 13.0607L12.8536 12.3536C13.0489 12.1583 13.0489 11.8417 12.8536 11.6464L9.41429 8.20711L12.8536 4.76777C13.0489 4.5725 13.0489 4.25592 12.8536 4.06066L12.1465 3.35355C11.9513 3.15829 11.6347 3.15829 11.4394 3.35355L8.00008 6.79289L4.56074 3.35355C4.36547 3.15829 4.04889 3.15829 3.85363 3.35355L3.14652 4.06066C2.95126 4.25592 2.95126 4.5725 3.14652 4.76777L6.58586 8.20711L3.14652 11.6464C2.95126 11.8417 2.95126 12.1583 3.14652 12.3536L3.85363 13.0607C4.04889 13.2559 4.36547 13.2559 4.56074 13.0607L8.00008 9.62132Z",
    fill: "currentColor"
  })));
};

export { IconCrossSmall };
